import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'
import { activityFeedQueryKey } from './activity.js'
import { ApiError } from './client.js'

/**
 * Manejo centralizado del 401 (CLAUDE.md §5): cualquier consulta que reciba
 * un 401 manda a `/login`. Es lo único que hace falta — un 401 en `useMe`
 * significa "no hay sesión" y el destino es el mismo que el de una sesión
 * caducada a media faena.
 */
function redirectToLogin(): void {
  if (window.location.pathname !== '/login') {
    window.location.assign('/login')
  }
}

function isUnauthenticated(error: unknown): boolean {
  return error instanceof ApiError && error.status === 401
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => !isUnauthenticated(error) && failureCount < 2,
    },
  },
  queryCache: new QueryCache({
    onError: (error) => {
      if (isUnauthenticated(error)) redirectToLogin()
    },
  }),
  /**
   * Casi cualquier escritura deja una fila nueva en `activity`: la actividad
   * reciente del Inicio se refresca aquí, en un solo sitio, en vez de que cada
   * mutación tenga que acordarse (fase 7).
   */
  mutationCache: new MutationCache({
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: activityFeedQueryKey })
    },
  }),
})
